<template>
  <main role="Product">
    <div class="row">
      <!-- <div class="col-md-12"> -->
      <ProductTable />
    </div>
    <!-- </div> -->
    <!-- </div> -->
  </main>
</template>

<script>
// import $ from 'jquery'

import ProductTable from "../Product/ProductTable";
// import store from "/src/store/index.js";

export default {
  components: {
    ProductTable,
  },
};
</script>

<style>
.toggle.ios,
.toggle-on.ios,
.toggle-off.ios {
  border-radius: 10rem !important;
  
}


.toggle.ios,
.toggle-on.ios,
.toggle-off.ios {
  border-radius: 20rem !important;
}
.toggle.ios .toggle-handle {
  border-radius: 20rem !important;
  background-color: rgb(53, 53, 53) !important;
  margin: 0px 0px 0px 0px !important;
}

.toggle-on {
  line-height: 12px !important;
  margin: 0px !important;
  color: #494949  !important;
  font-size: 10px !important;
}

.toggle-off {
  margin: 0px;
  color: #414141  !important;
  background-color: #b3b3b3 !important;

}

.toggle.btn {
  min-width: 33px !important;
  min-height: 20px !important; 
}

.btn,
.navbar .navbar-nav > a.btn {
  padding: 5px 15px;
}

.fa {
  margin-top: -3px;
}
.form-group .input-group-prepend .input-group-text,
.form-group .input-group-append .input-group-text,
.input-group .input-group-prepend .input-group-text,
.input-group .input-group-append .input-group-text {
  padding: 4px 1px 0px 12px;
}
</style>